var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GruposComponent',{attrs:{"electrovalvulas":_vm.electrovalvulas,"programacionesSecuenciales":_vm.programacionesSecuenciales,"grupos":_vm.grupos,"loader":_vm.loader}})
}
var staticRenderFns = []

export { render, staticRenderFns }